import channels from "./channels";

export const digisessionChannels = [channels.claro_pix_incentivo, channels.claro_youtube];

export default digisessionChannels;
